import { connect } from 'react-redux';
import { postDaoHo, setDaoHo } from 'actions/TraGop/DaoHo';
import ChiTietSoTienDaTra from 'components/CommonComponent/ChiTietSoTienDaTra';

const mapStateToProps = (state) => ({
  //data: state.data,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ChiTietSoTienDaTra);
